<template>
  <div>
    <h2 class="form__title">Неправильная ссылка</h2>
    <div class="form-row form-row_align-center">
      <p class="form__description form__description_align-center--all">
        Ссылка содержит ошибку или&nbsp;устарела
      </p>
    </div>
    <div class="form-row form-row_align-center">
      <a href="#" class="button button__lg button__blue" @click.prevent="handleButtonClick" v-html="buttonLabel"></a>
    </div>
  </div>
</template>

<script>
export default {
  name: "SignUpStepEmailBrokenLink",
  data() {
    return {
      isAuthenticated: null,
      buttonLabel: null
    }
  },
  props: {
    calculatedStep: String
  },
  created() {
    this.isAuthenticated = this.$store.state.profileData;
    this.buttonLabel = this.isEmailConfirmStep ? 'Отправить ссылку повторно' : 'Вернуться к&nbsp;регистрации';
  },
  methods: {
    handleButtonClick() {
      this.$emit('complete');
    }
  },
  computed: {
    isEmailConfirmStep() {
      return this.calculatedStep === 'email-confirm'
    }
  }
}
</script>
